import * as ambassadorWixAtlasV2Place from './atlas-v2-place-places.http.js';
import * as ambassadorWixAtlasV2PlaceTypes from './atlas-v2-place-places.types.js';
import * as ambassadorWixAtlasV2PlaceUniversalTypes from './atlas-v2-place-places.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getPlace(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAtlasV2PlaceUniversalTypes.GetPlaceRequest,
  ambassadorWixAtlasV2PlaceTypes.GetPlaceRequest,
  ambassadorWixAtlasV2PlaceUniversalTypes.GetPlaceResponse,
  ambassadorWixAtlasV2PlaceTypes.GetPlaceResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixAtlasV2Place.getPlace(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/place',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Place as PlaceOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  GetPlaceRequest as GetPlaceRequestOriginal,
  GetPlaceResponse as GetPlaceResponseOriginal,
} from './atlas-v2-place-places.types.js';
